import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// AUTH0
import { Auth0Provider } from "@auth0/auth0-react";

// CONTEXT
import { CartProvider } from "./context/CartContext";
import { WishlistProvider } from "./context/WishlistContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

const onRedirectCallback = (appState) => {
  window.history.replaceState(
    {},
    document.title,
    appState?.returnTo || window.location.pathname
  );
};

root.render(
  <React.StrictMode>
    <Auth0Provider
      domain="dev-b7bq47oc1ehukx31.us.auth0.com"
      clientId="0S9m6nJ9NDFZBgbYkuf66dQDgEu6SKul"
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: "https://ane-crochet-api", // ✅ FIXED
      }}
      onRedirectCallback={onRedirectCallback}
    >
      <CartProvider>
        <WishlistProvider>
          <App />
        </WishlistProvider>
      </CartProvider>
    </Auth0Provider>
  </React.StrictMode>
);
